import type { ReactNode } from 'react';

export const symbol_markunread_mailbox: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M240-565H140v425h680v-425H390q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h430q24 0 42 18t18 42v425q0 24-18 42t-42 18H140q-24 0-42-18t-18-42v-425q0-24 18-42t42-18h100v-225q0-12.75 8.63-21.38Q257.25-880 270-880h240q12.75 0 21.38 8.62Q540-862.75 540-850v100q0 12.75-8.62 21.37Q522.75-720 510-720H300v273q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-118Zm-100 0v425-425 148-148Z"
		/>
	</svg>
);
